import { StoreBonusStatusResponse } from '@common/models/bonus'
import cx from 'classnames'
import { useTranslations } from 'next-intl'

import { useCartContext } from '@/contexts/CartContext'
import { getDeliveredBonuses } from '@/features/storefronts/_storeBase/bonus/bonusUtils'
import { StoreTypography } from '@/features/storefronts/_storeBase/typography/StoreTypography'
import { useGameSlug } from '@/features/storefronts/game-provider'
import { useTranslatable } from '@/localization/useTranslatable'

import { BonusItemImage } from '../../shared/BonusItemImage'

import styles from './tentativeBonus.module.scss'

interface BonusTrackTentativeBonusProps {
  bonusStatus: StoreBonusStatusResponse
}

export const TentativeBonus = ({ bonusStatus }: BonusTrackTentativeBonusProps) => {
  const t = useTranslations()
  const translatable = useTranslatable()
  const gameSlug = useGameSlug()
  const { items } = useCartContext()
  const deliveredBonuses = getDeliveredBonuses({ bonusStatus, items })
  const numberOfDeliveredItems = deliveredBonuses.length

  return numberOfDeliveredItems > 0 ? (
    <div className={cx(styles.bonusTrackTentativeBonus, styles[gameSlug])}>
      <div className={styles.tentativeBonusContent}>
        <StoreTypography
          className={styles.containerTitle}
          tag="h3"
          textSize="sm"
          style="plain"
          overrideFont="supercellText"
        >
          {t('bonus_delivered_on_checkout')}
        </StoreTypography>

        <div className={styles.deliveredContainer}>
          {deliveredBonuses.map((item) => (
            <div className={styles.tentativeBonusItem} key={item.id}>
              <div className={styles.deliveredImageContainer}>
                <BonusItemImage item={item} status="delivered" />
              </div>
              <div className={styles.itemDetails}>
                <StoreTypography
                  className={styles.itemName}
                  tag="h3"
                  textSize="body"
                  style="plain"
                  overrideFont="supercellHeadline"
                >
                  {translatable(item.title, 'title')}
                </StoreTypography>

                <StoreTypography
                  className={styles.itemDescription}
                  tag="p"
                  textSize="sm"
                  style="plain"
                  overrideFont="supercellText"
                >
                  {t('bonus_track_item')}
                </StoreTypography>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  ) : null
}
